import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import {
  ServiceCardActions,
  ServiceCardEventEmitterDataHolder,
} from '../../../shared/service-card/ServiceCardEventEmitterDataHolder';
import {
  FavoriteServiceHybrid,
  ServicesListDataService,
} from '../../../core/api-services/shared/services/ServicesListDataService';

import {
  fadeAnimation,
  scaleY,
} from 'src/app/shared/animations/fade.animation';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';

@Component({
  selector: 'favorite-services',
  templateUrl: './favorite-services.component.html',
  animations: [fadeAnimation, scaleY],
})
export class FavoriteServicesComponent extends BaseComponent {
  searchText = '';
  isShowAllServices = false;

  private searchTextSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private servicesListDataService: ServicesListDataService,
    translateService: TranslateService,
    private analyticsService: AnalyticsService
  ) {
    super(translateService);

    this.searchTextSubject
      .pipe(debounceTime(5000), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((searchText) => {
        this.analyticsService.internalSearch({ searchQuery: searchText });
      });
  }

  public onSearchTextChange(value: string): void {
    this.searchTextSubject.next(value);
  }

  public get $allServices() {
    return this.servicesListDataService.$allServices;
  }

  public async toggleFavorite(service: FavoriteServiceHybrid): Promise<void> {
    await this.servicesListDataService.updateFavorite(
      service.serviceDetails.attr.digitalservice,
      service.isFavorite == false
    );
  }

  public async fetchServiceMetadata(
    service: FavoriteServiceHybrid,
    lang: string
  ): Promise<void> {
    const metadata = await this.servicesListDataService.fetchServiceDetails(
      service.serviceDetails.attr.digitalservice,
      lang
    );

    service.metadata = metadata;
    service.expanded = metadata != null;
  }

  public collapse(service: FavoriteServiceHybrid): void {
    service.expanded = false;
  }

  public onServiceCardAction($event: ServiceCardEventEmitterDataHolder) {
    switch ($event.action) {
      case ServiceCardActions.ToggleFavorite:
        this.toggleFavorite($event.data);
        break;
      case ServiceCardActions.FetchMetadata:
        this.fetchServiceMetadata($event.data, this.lang);
        break;
      case ServiceCardActions.Collapse:
        this.collapse($event.data);
        break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
